import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRow, FlexRowCenterVertical, IconImg, TextP } from '../../..';
import { ConditionText, StyledH3, StyledTitle, Wrapper } from './Description';
import { Table, TableRow, TableTd } from '../../Zemplin/General/Table';
import { Button } from '../../Zemplin/General/Button';
import { __ } from 'react-i18n';
import { getFilePath } from '../../../utilities/product';

interface SpecificationProps {
  specification: string;
  isOpen: boolean;
  documents?: any;
  downloads?: any;
  condition?: string;
  attribs?: { name: string, values:{value: string}[]}[]
}

function Specification(props:SpecificationProps) {
  const { specification, isOpen, documents, condition, attribs } = props;

  const renderDownloadItem = () => {
    const items = documents.map((item, index) => {
      return (
        <DownloadItem
          href={getFilePath(item.document_path)}
          key={index}
          target="_blank"
        >
          <StyledButton>
            <FlexRowCenterVertical>
              <IconImg
                width={24}
                height={24}
                src={'/assets/dsi/download.svg'}
              />
              <DownloadText>{item.document_name}</DownloadText>
            </FlexRowCenterVertical>
            {/* <DownloadSize>{__(`24MB`)}</DownloadSize> */}
          </StyledButton>
        </DownloadItem>
      );
    });
    return items;
  };

  return (
    <>
      <Wrapper isOpen={isOpen}>
        {condition && condition !== '' && (
          <ConditionText>{condition}</ConditionText>
        )}
        {specification && specification !== '' ? (
          <>
            {/* <StyledTitle>{__(`Špecifikácia`)}</StyledTitle> */}
            <DescWrapper dangerouslySetInnerHTML={{ __html: specification }} />
          </>
        ) : (
           <>
             {attribs?.length?
                <ul>
                  {attribs?.map(attrib => {
                      return <li> <strong> {attrib.name}: </strong> {attrib.values.map(value => value.value).join(', ')} </li>
                  })}
                </ul>
              : <StyledTitle>{__(`Žiadna špecifikácia`)}</StyledTitle>
             }
           </>
        )}
        {/*<SpecificationItem>*/}
        {/*  <SpecificationName>{`JBL Pure Bass zvuk`}</SpecificationName>*/}
        {/*  <TextP>{`Slúchadlá majú renomovaný JBL Pure Bass zvuk, ktorý je možné nájsť na najznámejších miestach po celom svete.`}</TextP>*/}
        {/*</SpecificationItem>*/}
        {/*<SpecificationItem>*/}
        {/*  <SpecificationName>{`Diaľkový ovládač/mikrofón s jedným tlačidlom`}</SpecificationName>*/}
        {/*  <TextP>{`Jednoduché ovládanie hudby, telefonických hovorov a prístup k technológii Siri/Google Now pomocou dotyku jediného tlačidla.`}</TextP>*/}
        {/*</SpecificationItem>*/}
        {/*<SpecificationItem>*/}
        {/*  <SpecificationName>{`Ľahký a sklápací dizajn`}</SpecificationName>*/}
        {/*  <TextP>{`Vďaka ľahkým materiálom a sklápaciemu prevedeniu sú tieto slúchadlá jednoduché na nosenie kdekoľvek a kedykoľvek, keď budete chcieť počúvať hudbu.`}</TextP>*/}
        {/*</SpecificationItem>*/}
        {/*<StyledTable>*/}
        {/*  <StyledTableRow>*/}
        {/*    <StyledTableTd>{`Veľkosť meniča`}</StyledTableTd>*/}
        {/*    <StyledTableTd>{`32 mm dynamický menič`}</StyledTableTd>*/}
        {/*  </StyledTableRow>*/}
        {/*  <StyledTableRow>*/}
        {/*    <StyledTableTd>{`Frekvenčná odozva`}</StyledTableTd>*/}
        {/*    <StyledTableTd>{`20 Hz – 20 kHz`}</StyledTableTd>*/}
        {/*  </StyledTableRow>*/}
        {/*  <StyledTableRow>*/}
        {/*    <StyledTableTd>{`Hmotnosť`}</StyledTableTd>*/}
        {/*    <StyledTableTd>{`148 g`}</StyledTableTd>*/}
        {/*  </StyledTableRow>*/}
        {/*</StyledTable>*/}
        {/*<SpecificationItem>*/}
        {/*  <SpecificationName>{`Obsah balenia`}</SpecificationName>*/}
        {/*  <TextP>{`Slúchadlá TUNE500, 1 x Záručný list`}</TextP>*/}
        {/*</SpecificationItem>*/}
        {/*<StyledH3>{`Na stiahnutie`}</StyledH3>*/}
        {documents && documents.length > 0 && (
          <>
            <StyledTitle>{__(`Na stiahnutie`)}</StyledTitle>
            <Downloads>{documents && renderDownloadItem()}</Downloads>
          </>
        )}
      </Wrapper>
    </>
  );
}

const DescWrapper = styled.div`
  & img {
    height: auto;
    margin: 0 auto;
  }
`;

const SpecificationItem = styled.div`
  margin-bottom: ${rem(32)};
`;

const SpecificationName = styled(TextP)`
  font-size: ${rem(18)};
  font-weight: 500;
`;

const StyledTable = styled(Table)`
  margin-bottom: ${rem(32)};
`;

const StyledTableRow = styled(TableRow)`
  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.blogColors.background};
  }
`;

const StyledTableTd = styled(TableTd)`
  padding: ${rem(16)};
`;

const Downloads = styled(FlexRow)`
  justify-content: space-between;
  ${({ theme }) => theme.mediab.m600`
    flex-direction: column;
  `}
`;

const StyledButton = styled(Button)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(204, 204, 204, 1);
  border-radius: ${rem(4)};
  padding: ${rem(16)} ${rem(24)};
  height: initial;
`;

const DownloadItem = styled.a`
  width: 49%;
  ${({ theme }) => theme.mediab.m600`
    width: 100%;
    margin-bottom: ${rem(8)};
  `}
  text-decoration: none;
`;

const DownloadSize = styled(TextP)`
  text-align: right;
  font-size: ${rem(16)};
  line-height: ${rem(20)} !important;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const DownloadText = styled(DownloadSize)`
  margin-left: ${rem(16)};
  text-align: left;
  font-weight: 500;
`;

export { Specification as DsiSpecification };
